// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.project-warning {
    background: #EB7038;
    color: white;
    display: flex;
    flex-direction: row;
    font-size: 17px;
    padding: 1em;
    gap: 1em;
    align-items: center;
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 10000;
    width: 100%;
    box-sizing: border-box;
}

.project-warning .close-button {
    position: absolute;
    top: 4px;
    right: 6px;
    cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/widgets/Survey/ProjectWarning.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,YAAY;IACZ,QAAQ;IACR,mBAAmB;IACnB,eAAe;IACf,SAAS;IACT,OAAO;IACP,cAAc;IACd,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,eAAe;AACnB","sourcesContent":[".project-warning {\n    background: #EB7038;\n    color: white;\n    display: flex;\n    flex-direction: row;\n    font-size: 17px;\n    padding: 1em;\n    gap: 1em;\n    align-items: center;\n    position: fixed;\n    bottom: 0;\n    left: 0;\n    z-index: 10000;\n    width: 100%;\n    box-sizing: border-box;\n}\n\n.project-warning .close-button {\n    position: absolute;\n    top: 4px;\n    right: 6px;\n    cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
